module.exports = __webpack_public_path__ + "media/application/images/svgs/user-6f3b682ec2b6067e0aa8834d5d545d83.svg";